module.exports = __webpack_public_path__ + "img/en-banner.99f7f25a.png";